import { Button, Grid, TextField } from '@material-ui/core';
import React from 'react';
import ChowbusDialog from '~/components/ui-kit/ChowbusDialog/ChowbusDialog';
import GoogleMap from '../GoogleMap';
import GoogleMapsAutocomplete from './GoogeMapsAutocomplete';
import PlaceIcon from '~/assets/place.png';
import { addressFromGoogleMapsPlace } from '~/models/Addresses/addresses';
import { useDispatch } from 'react-redux';
import * as userActions from '~/store/legacy/actions/userActions';
import * as locationApi from '~/api/locationApi';
import { userCookie } from '~/models/UserCookie';
import { fbEvents } from '~/third_party/Facebook';
import { openAlert } from '~/store/legacy/actions/alertActions';
import { useIntl } from 'react-intl';

export default AddAddressDialog;

function AddAddressDialog(props) {
  const dispatch = useDispatch();
  const intl = useIntl();
  const [place, setPlace] = React.useState(null);
  const [userPostalCode, setUserPostalCode] = React.useState('');
  const [userUnitNumber, setUserUnitNumber] = React.useState('');
  const [chowbusAddress, setChowbusAddress] = React.useState(null);

  const onPlaceSelected = (selectedPlace) => {
    setPlace(selectedPlace);
    const cbAddr = addressFromGoogleMapsPlace(selectedPlace, { validateDeliverable: true });
    setChowbusAddress(cbAddr);
    setUserPostalCode(cbAddr.zip_code);
  };

  const onUserUnitNumberChange = (event) => {
    setUserUnitNumber(event.target.value);
  };

  const onUserPostalCodeChange = (event) => {
    setUserPostalCode(event.target.value);
  };

  const onSaveAddress = async () => {
    const finalAddress = {
      ...chowbusAddress,
      address_2: userUnitNumber,
      zip_code: userPostalCode,
    };

    //face book pixel event
    fbEvents.trackEnterLocation();
    if (userCookie.isLoggedIn) {
      dispatch(userActions.setNewUserSearchAddress(finalAddress));
    } else {
      const serviceRegions = await locationApi.getServiceRegionsByAddress(finalAddress);
      if (serviceRegions && serviceRegions[0]) {
        dispatch(userActions.chooseCurrentAddress(finalAddress, serviceRegions[0].id));
      } else {
        dispatch(
          openAlert({
            variant: 'error',
            message: intl.formatMessage({ id: 'actions.new_address.invalid_address' }),
          })
        );
      }
    }

    props.onClose(true);
  };

  return (
    <ChowbusDialog title='Enter a New Address' isDialogOpen={true} onCloseDialog={props.onClose}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <GoogleMapsAutocomplete onPlaceSelected={onPlaceSelected} />
        </Grid>
        <Grid item xs={6}>
          <TextField
            inputProps={{
              'aria-label': 'Unit Number',
            }}
            label='Unit #'
            name='unitNumber'
            variant='outlined'
            value={userUnitNumber}
            onChange={onUserUnitNumberChange}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            inputProps={{
              'aria-label': 'Postal Code',
            }}
            label='Postal Code'
            name='postalCode'
            variant='outlined'
            value={userPostalCode}
            onChange={onUserPostalCodeChange}
          />
        </Grid>
        <Grid item xs={12} style={{ height: 250 }}>
          {place && (
            <GoogleMap
              id='add-address-map'
              center={place.geometry.location}
              items={[
                {
                  id: 'selected-address',
                  position: place.geometry.location,
                  icon: {
                    googleMapsScaledSize: [48, 48],
                    fillOpacity: 1,
                    url: PlaceIcon,
                  },
                },
              ]}
            />
          )}
        </Grid>
        <Grid item xs={12} style={{ textAlign: 'center' }}>
          <Button
            variant='contained'
            color='primary'
            disabled={!place}
            onClick={onSaveAddress}
            aria-label='Save Address'>
            Save Address
          </Button>
        </Grid>
      </Grid>
    </ChowbusDialog>
  );
}
